import { Injectable } from '@angular/core';
import { userDemo } from '../../model/userDemo';
import { Token } from "../../model/token";
import { TYPE_ROLES } from '../../constants/typeRoles';


/*Singleton para acceso al token entre componentes*/
@Injectable()
export class TokenControlService {

  //Objeto token con la informacion obtenida desde plexi-rest
  public token: Token;

  public userDemo: userDemo;
  //constructor de la clase
  constructor() { }

  //Se encarga de obtener el valor del token
  public getTokenValue(): string {
    if (this.token) {
      return this.token.token;
    } else {
      return '';
    }
  }

  public isRoleReview(): Boolean {
    return this.token && this.token.userType == TYPE_ROLES.REVIEW
  }

}
